import {O} from "web-vcore";

/** Renderer-thread singleton with per-frame scenery counts (instanced + billboarded), written by
 *  `SceneryRenderer.tsx` each `useFrame` and read by the map-UI Stats panel (mirrors
 *  `TerrainProcessStats`/`mapRenderStats`). Lets the Stats panel answer "are the trees actually
 *  being instanced/billboarded right now?" without reaching into the three.js scene graph.
 *
 *  The two totals are what the user asked for:
 *    - instancedTreeCount — Set15 P7 NEAR-tier REAL meshes (per-variant InstancedMesh bark+leaf,
 *      real geometry). This is the "instanced" number.
 *    - billboardedTreeCount — the FAR-tier 3D cylindrical-billboard InstancedMesh (or, in 2D, the
 *      single flat tree quad InstancedMesh). This is the "billboarded" number.
 *  In 2D every tree is the flat quad (billboarded) and none are the near-tier real mesh.
 */
class SceneryRenderStatsStore {
	/** Total near-tier REAL-mesh instances across all kinds (Set15 P7 InstancedMesh bark+leaf).
	 *  `null` until the scenery renderer pushes its first frame. */
	@O accessor instancedTreeCount: number | null = null;

	/** Total far-tier billboard instances across all kinds (3D cylindrical billboards, or the 2D
	 *  flat tree-quad InstancedMesh). `null` until the scenery renderer pushes its first frame. */
	@O accessor billboardedTreeCount: number | null = null;

	/** Number of scenery kinds currently rendering (for context in the Stats panel). */
	@O accessor kindCount: number = 0;

	/** Whether the current render is perspective (3D) or ortho (2D) — the counts mean different
	 *  things in each (in 3D there is a real instanced near tier; in 2D everything is a billboard). */
	@O accessor isPerspective: boolean | null = null;
}

export const sceneryRenderStats = new SceneryRenderStatsStore();
